// @flow

import type {CallInfo} from '../typedef';

type GetUrl = (callInfo: CallInfo<*>, apiRoot: string) => string;

export const getUrl: GetUrl = (callInfo, apiRoot) => {
    const {endpoint} = callInfo;

    if (callInfo.apiRoot === null) {
        return endpoint;
    }

    const prefix = callInfo.apiRoot || apiRoot;

    if (prefix.endsWith('/') && endpoint.startsWith('/')) {
        return prefix + endpoint.slice(1);
    }

    return prefix + endpoint;
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
